import './md5';
export function md5(str) {
  let res = '';
  try {
    res = window.md5(str);
  } catch (e) {
    console.log(e);
  }
  return res;
}

export { latexToHtml, hasLatexFormula, loadMathJaxScript } from './latexToHtml';
